import { Box } from "@chakra-ui/layout";
import useTiposAreaComum from "core/features/area-comum/hooks/useTiposAreaComum";
import colors from "core/resources/theme/colors";
import React from "react";
import { getIconForAreaComum } from "../util/helper";

interface FiltroTipoAreaComumProps {
  selectedTipoAreaComum?: string;
  setSelectedTipoAreaComum?: (id?: string) => any;
}
function FiltroTipoAreaComum({
  selectedTipoAreaComum,
  setSelectedTipoAreaComum,
}: FiltroTipoAreaComumProps) {
  const { data } = useTiposAreaComum();
  const onSelectTipoAreaComum = (t: string) => {
    if (selectedTipoAreaComum === t) {
      setSelectedTipoAreaComum?.(undefined);
    } else {
      setSelectedTipoAreaComum?.(t);
    }
  };

  const items = data?.filter((i) => !!i.icone).slice(0, 4);

  return (
    <>
      {items?.map((i) => (
        <IconWrapper
          onClick={() => onSelectTipoAreaComum?.(i.id)}
          selected={selectedTipoAreaComum === i.id}
        >
          {getIconForAreaComum(i.icone!)}
        </IconWrapper>
      ))}
    </>
  );
}

const IconWrapper = ({
  onClick,
  selected,
  children,
}: {
  onClick: () => any;
  selected: boolean;
  children: React.ReactNode;
}) => (
  <Box
    cursor="pointer"
    rounded="full"
    onClick={onClick}
    borderWidth={2}
    _hover={{
      boxShadow: `0 0 0 2px ${colors.primary}`,
      outlineColor: colors.primary,
    }}
    transition="all 0.3s"
    borderColor={selected ? colors.primary : "transparent"}
  >
    {children}
  </Box>
);

export default FiltroTipoAreaComum;
